"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = inputProps;
var _extendLodash = require("../extendLodash");
var KEYS = ['value', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDrop', 'onFocus'];
function inputProps(field) {
  return (0, _extendLodash.uuPick)(field, KEYS);
}